import { render } from "./WebViewer.vue?vue&type=template&id=637c5f0a"
import script from "./WebViewer.vue?vue&type=script&lang=js"
export * from "./WebViewer.vue?vue&type=script&lang=js"

import "./WebViewer.vue?vue&type=style&index=0&id=637c5f0a&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__